import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { getQuestions } from "../../features/Questions/questionSlice";
import { Bar, Pie } from "react-chartjs-2";
import "./analysis.css";
import { getTitle } from "./../../features/Questions/questionSlice";
// import Header from './Header';

function Analysis({ giveDataToParent }) {
  const Questions = useSelector(getQuestions);
  const title = useSelector(getTitle);
  let time = [0, 0, 0];
  let score = [0, 0, 0];
  let visited = [0, 0, 0];
  let unvisited = [0, 0, 0];
  let correct = [0, 0, 0];
  let incorrect = [0, 0, 0];
  let leftQuestion = [0, 0, 0];
  let correctScore = [0, 0, 0];
  let incorrectScore = [0, 0, 0];
  let attemptedQuestions = [0, 0, 0];
  let totalTime = title.startsWith("FULL") ? 180 : 60;
  let numericalIncorrect = 0;
  let calculationDone = false;
  useEffect(() => {
    giveDataToParent(score);
  }, [calculationDone]);

  for (let i = 0; i < Questions.length; i++) {
    let q = Questions[i];
    //   console.log(q.subject, q.time, "subject");
    if (q.subject === "phy") {
      time[0] += q.time;
      if (q.type !== "unvisited") {
        visited[0] += 1;
        if (q.attempted !== "") {
          attemptedQuestions[0] += 1;
          if (q.ans == q.attempted) correct[0] += 1;
          else incorrect[0] += 1;
        } else leftQuestion[0]++;
      } else unvisited[0] += 1;
    }
    if (q.subject === "chem") {
      time[1] += q.time;
      if (q.type !== "unvisited") {
        visited[1] += 1;
        if (q.attempted !== "") {
          attemptedQuestions[1] += 1;
          if (q.ans == q.attempted) correct[1] += 1;
          else incorrect[1] += 1;
        } else leftQuestion[1]++;
      } else unvisited[1] += 1;
    }
    if (q.subject === "math") {
      time[2] += q.time;
      if (q.type !== "unvisited") {
        visited[2]++;
        if (q.attempted !== "") {
          attemptedQuestions[2] += 1;
          if (q.ans == q.attempted) correct[2] += 1;
          else incorrect[2] += 1;
        } else leftQuestion[2]++;
      } else unvisited[2] += 1;
    }
  }
  time[0] = time[0] / 60000;
  time[1] = time[1] / 60000;
  time[2] = time[2] / 60000;
  time[3] = totalTime - time[0] + time[1] + time[2];
  // setTime(time);
  // setScore(score);
  for (let i = 0; i < correct.length; i++) {
    score[i] = correct[i] * 4 - incorrect[i];
    correctScore[i] = correct[i] * 4;
    incorrectScore[i] = incorrect[i] * -1;
  }
  calculationDone = true;

  // let total_Questions =
  //   (title.startsWith("FULL") && [30, 30, 30]) ||
  //   (title.startsWith("PHYS") && [30, 0, 0]) ||
  //   (title.startsWith("CHEM") && [0, 30, 0]) ||
  //   (title.startsWith("MATH") && [0, 0, 30]);
  let timePieData = {
    labels: ["Physics", "Chemistry", "Maths", "Left"],
    datasets: [
      {
        data: time,
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(84,46,113,0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(84,46,113,1)",
        ],
        borderWidth: 2,
      },
    ],
  };

  let scorePieData = {
    labels: ["Physics", "Chemistry", "Maths"],
    datasets: [
      {
        data: score,
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
        ],
        borderWidth: 2,
      },
    ],
  };
  let barData = {
    labels: ["Physics", "Chemistry", "Math"],
    datasets: [
      {
        label: "Correct Questions",
        data: correct,
        backgroundColor: "rgb(54, 162, 235)",
      },
      {
        label: "Attempted Questions",
        data: attemptedQuestions,
        backgroundColor: "rgb(255, 99, 132)",
      },
      {
        label: "Visited Questions",
        data: visited,
        backgroundColor: "rgb(75, 192, 192)",
      },
      // {
      //     label: "Total Questions",
      //     data : total_Questions,
      //     backgroundColor: "rgba(0,0,0,0.5)",
      // },
    ],
  };

  let scoreBarData = {
    labels: ["Physics", "Chemistry", "Math"],
    datasets: [
      {
        label: "Correct Questions Score",
        data: correctScore,
        backgroundColor: "rgb(54, 162, 235)",
      },
      {
        label: "Wrong Questions Score",
        data: incorrectScore,
        backgroundColor: "rgba(0,0,0,0.5)",
      },
      {
        label: "Total Score",
        data: score,
        backgroundColor: "rgb(255, 99, 132)",
      },
    ],
  };

  // }, [Questions]);
  //   console.log(tempPieData);
  return (
    <>
      <div className="d-flex graphs">
        <div className="d-flex flex-column barCharts">
          {barData && (
            <div className="d-flex flex-column justify-center py-2">
              <p className="text-center"></p>
              <div className="bar">
                <Bar options={{ maintainAspectRatio: false }} data={barData} />
              </div>
            </div>
          )}
          {scoreBarData && (
            <div className="d-flex flex-column justify-center py-2">
              <p className="text-center"></p>
              <div className="bar">
                <Bar
                  options={{ maintainAspectRatio: false }}
                  data={scoreBarData}
                />
              </div>
            </div>
          )}
        </div>
        <div className="d-flex pieCharts">
          <div className="data"></div>
          {timePieData && (
            <div className="d-flex flex-column justify-center PieData">
              <>
                {" "}
                <p className="text-center">Time Distribution (minutes)</p>
              </>
              <div className="pie time">
                <Pie data={timePieData} />
              </div>
            </div>
          )}
          {scorePieData && (
            <div className="d-flex flex-column justify-center PieData">
              <>
                {" "}
                <p className="text-center">Score Distribution</p>
              </>
              <div className="pie time">
                <Pie data={scorePieData} />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Analysis;
